<template>
  <div>
    <v-form v-model="valid" lazy-validation>
      <v-container :class="ui.bkgdColor">
        <div v-if="enableMaterialFields">
          <v-layout row :class="ui.textSubheading">
            <div class="ml-4 mt-4 mb-4">
              Parts Order
            </div>
          </v-layout>
          <v-layout row wrap class="ml-2 mr-2">
            <v-flex xs12 md8 lg6>
              <v-text-field
              :label="getDetail.link.st"
              prepend-icon="category"
              hint="material name"
              persistent-hint
              outline
              readonly
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="ml-2 mr-2">
            <v-flex xs12 sm8 lg8>
              <v-text-field
              :label="getDetail.link.sid"
              prepend-icon="pin"
              hint="material id"
              persistent-hint
              outline
              readonly
              ></v-text-field>
            </v-flex>
            <v-flex xs sm4 lg4>
              <v-text-field
              :label="getDetailChar.qty"
              prepend-icon="grain"
              hint="QTY"
              persistent-hint
              outline
              readonly
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="ml-2 mr-2">
            <v-flex xs12 md8 lg6>
              <v-text-field
              v-model="localForm.costo"
              :change="updateFormChar()"
              :rules="mustBeZeroOrMore"
              :suffix="this.getDetailChar.costu"
              prepend-icon="paid"
              hint="actual cost"
              persistent-hint
              required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md8 lg6>
              <v-text-field
              v-model="localForm.carbo"
              :change="updateFormChar()"
              :rules="mustBeZeroOrMore"
              :suffix="this.getDetailChar.carbu"
              prepend-icon="co2"
              hint="actual carbon"
              persistent-hint
              required
              ></v-text-field>
            </v-flex>
          </v-layout>
        </div>
        <div v-if="enablePartFields">
          <v-layout row :class="ui.textSubheading">
            <div class="ml-4 mt-4 mb-4">
              Work Parts Order
            </div>
          </v-layout>
          <v-layout row wrap class="ml-2 mr-2">
            <v-flex xs12 sm8 md8 lg6>
              <v-text-field
              :label="getDetailChar.ordn"
              prepend-icon="category"
              hint="work part"
              persistent-hint
              outline
              readonly
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm4 lg4>
              <v-text-field
              :label="getDetailChar.ordq"
              prepend-icon="grain"
              hint="QTY"
              persistent-hint
              outline
              readonly
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="ml-2 mr-2">
            <v-flex xs12 sm8 md8 lg6>
              <v-text-field
              :label="getDetailChar.ordi"
              prepend-icon="pin"
              hint="work id"
              persistent-hint
              outline
              readonly
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm4 lg4>
              <v-text-field
              :label="getDetailChar.ordt"
              prepend-icon="grid_view"
              hint="type"
              persistent-hint
              outline
              readonly
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="ml-2 mr-2">
            <v-flex xs12 sm10 md9 lg9>
              <v-text-field
              :label="getDetailChar.ordc"
              prepend-icon="short_text"
              hint="work part comments"
              persistent-hint
              outline
              readonly
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="ml-2 mr-2">
            <v-flex xs12 md8 lg6>
              <v-text-field
              v-model="localForm.costo"
              :change="updateFormChar()"
              :rules="mustBeZeroOrMore"
              :suffix="this.getDetailChar.costu"
              prepend-icon="paid"
              hint="actual cost per item"
              persistent-hint
              required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md8 lg6>
              <v-text-field
              v-model="localForm.carbo"
              :change="updateFormChar()"
              :rules="mustBeZeroOrMore"
              :suffix="this.getDetailChar.carbu"
              prepend-icon="co2"
              hint="actual carbon per item"
              persistent-hint
              required
              ></v-text-field>
            </v-flex>
          </v-layout>
        </div>
        <div v-if="enableServiceFields">
          <v-layout row :class="ui.textSubheading">
            <div class="ml-4 mt-4">
              Service Order
            </div>
          </v-layout>
          <v-layout row wrap class="ml-2 mr-2">
            <v-flex xs12 sm8 md8 lg6>
              <v-text-field
              :label="getDetailChar.ordn"
              prepend-icon="person"
              hint="work service"
              persistent-hint
              outline
              readonly
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm4 lg4>
              <v-text-field
              :label="getDetailChar.ordq"
              prepend-icon="person_add"
              hint="person-hrs"
              persistent-hint
              outline
              readonly
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="ml-2 mr-2">
            <v-flex xs12 sm6 lg6>
              <v-text-field
              :label="getDetailChar.ordi"
              prepend-icon="pin"
              hint="service id"
              persistent-hint
              outline
              readonly
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm4 lg4>
              <v-text-field
              :label="getDetailChar.ordt"
              prepend-icon="grid_view"
              hint="type"
              persistent-hint
              outline
              readonly
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="ml-2 mr-2">
            <v-flex xs12 md8 lg6>
              <v-text-field
              :change="updateFormChar()"
              v-model="localForm.costo"
              :rules="ruleNumberMoreThanZero"
              prepend-icon="paid"
              :suffix="this.getDetailChar.costu"
              hint="total actual cost"
              persistent-hint
              required
              ></v-text-field>
            </v-flex>
          </v-layout>
        </div>
        <div>
        <v-layout row :class="ui.textSubheading">
          <div class="ml-4 mt-4">
            Order Details
          </div>
        </v-layout>
        <v-layout row wrap class="ml-3 mr-2 mt-2">
          <v-flex xs12>
            <v-textarea
            :change="updateFormChar()"
            :color="ui.textColor"
            :background-color="ui.btnColor"
            v-model="localForm.order"
            :disabled="false"
            :outline="true"
            :rules="ruleMustBeNotUndefinedANDLessThan2000"
            hint="order requirements"
            auto-grow
            persistent-hint
            ></v-textarea>
          </v-flex>
        </v-layout>
        <v-layout row wrap class="ml-2 mr-2">
          <v-flex xs12 md8 lg6>
            <v-text-field
            :change="updateFormChar()"
            v-model="localForm.vt"
            :rules="ruleMustBeFilledANDLessThan50"
            prepend-icon="manage_accounts"
            hint="vendor name"
            persistent-hint
            required
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md8 lg6>
            <v-text-field
            :change="updateFormChar()"
            v-model="localForm.vid"
            :rules="ruleMustBeFilledANDLessThan50"
            prepend-icon="fingerprint"
            hint="vendor id"
            persistent-hint
            required
            ></v-text-field>
          </v-flex>
        </v-layout>
        </div>
        <v-layout row class="mb-4">
        </v-layout>
        <v-layout row class="mb-4">
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>

<script>
import docRevsModFunctions from "@/document/revisions/mixins/docRevsModFunctions.js";
import ruleTextfield from "@/data/rules/mixins/rulesTextfield.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import orderOptions from "@/data/options/mixins/orderOptions.js";
import techOptions from "@/data/options/mixins/techOptions.js";
import financeFunctions from "@/data/functions/mixins/financeFunctions.js";

import { mapGetters } from "vuex";
export default {
  data() {
    return {
      valid: true,
      localForm: {
        costo: "",
        carbo: "",
        per: "",
        hrs: "",
        order: "",
        vid: "",
        vt: ""
      },
      orgForm: {
        costo: "",
        carbo: "",
        per: "",
        hrs: "",
        order: "",
        vid: "",
        vt: ""
      }
    };
  },
  beforeMount() {
    // fix orginal data before change
    this.localForm.vt = this.getDetail.char.vt;
    this.localForm.vid = this.getDetail.char.vid;
    this.localForm.order = this.getDetail.char.order;
    this.localForm.hrs = this.getDetail.char.hrs;
    this.localForm.per = this.getDetail.char.per;

    this.orgForm.order = this.getDetail.char.order;
    this.orgForm.vt = this.getDetail.char.vt;
    this.orgForm.vid = this.getDetail.char.vid;
    this.orgForm.hrs = this.getDetail.char.hrs;
    this.orgForm.per = this.getDetail.char.per;

    if (this.getDetail.char.type === "ML1") {
      this.localForm.costo = this.getDetail.char.costo;
      this.orgForm.costo = this.getDetail.char.costo;
      this.localForm.carbo = this.getDetail.char.carbo;
      this.orgForm.carbo = this.getDetail.char.carbo;
    }
    if (this.getDetail.char.type === "PW1") {
      let cost = parseFloat(this.getDetail.char.costo);
      let carb = parseFloat(this.getDetail.char.carbo);
      // let qty = parseFloat(this.getDetail.char.ordq);
      let costo = cost * 1;
      let carbo = carb * 1;
      this.localForm.costo = costo;
      this.orgForm.costo = costo;
      this.localForm.carbo = carbo;
      this.orgForm.carbo = carbo;
    }
    if (this.getDetail.char.type === "SW1") {
      let costo = this.getDetail.char.costo;
      this.localForm.costo = costo;
      this.orgForm.costo = costo;
    }
  },
  // eslint-disable-next-line
  mixins: [
    docRevsModFunctions,
    ruleTextfield,
    apptheme,
    orderOptions,
    techOptions,
    financeFunctions
  ],
  computed: {
    ...mapGetters(["getDetail", "getDetailChar", "getCurrentPage"]),
    enableMaterialFields() {
      let logic = null;
      if (
        this.getDetailChar.type === "ML1" ||
        this.getDetailChar.type === "MW1" ||
        this.getDetailChar.type === "MW2"
      ) {
        logic = true;
      } else {
        logic = false;
      }
      return logic;
    },
    enablePartFields() {
      let logic = null;
      if (this.getDetailChar.type === "PW1") {
        logic = true;
      } else {
        logic = false;
      }
      return logic;
    },
    enableServiceFields() {
      let logic = null;
      if (
        this.getDetailChar.type === "SE2" ||
        this.getDetailChar.type === "SW1" ||
        this.getDetailChar.type === "SW2"
      ) {
        logic = true;
      } else {
        logic = false;
      }
      return logic;
    }
  },
  methods: {
    updateFormChar() {
      let char = this.getDetailChar;
      // eslint-disable-next-line
      if (
        this.localForm.costo !== this.orgForm.costo &&
        this.localForm.costo !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.costo = this.localForm.costo;
        // basic
        char.costo = this.localForm.costo;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.17, 1); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (this.localForm.vt !== this.orgForm.vt && this.localForm.vt !== "") {
        // after the change re-assign new Local to Org
        this.orgForm.vt = this.localForm.vt;
        // basic
        char.vt = this.localForm.vt;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.17, 4); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.vid !== this.orgForm.vid &&
        this.localForm.vid !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.vid = this.localForm.vid;
        // basic
        char.vid = this.localForm.vid;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.17, 5); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.carbo !== this.orgForm.carbo &&
        this.localForm.carbo !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.carbo = this.localForm.carbo;
        // basic
        char.carbo = this.localForm.carbo;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.17, 6); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.order !== this.orgForm.order &&
        this.localForm.order !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.order = this.localForm.order;
        // basic
        char.order = this.localForm.order;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(5.21, 7); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.hrs !== this.orgForm.hrs &&
        this.localForm.hrs !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.hrs = this.localForm.hrs;
        // basic
        char.hrs = this.localForm.hrs;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(5.21, 8); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.per !== this.orgForm.per &&
        this.localForm.per !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.per = this.localForm.per;
        // basic
        char.per = this.localForm.per;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(5.21, 8); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }
    }
  }
};
</script>
